import React from 'react';
import { LinkedinLogo as LinkedinLogoIcon, EnvelopeSimple as EnvelopeSimpleIcon, WhatsappLogo as WhatsappLogoIcon, QrCode as QrCodeIcon, FlagBanner as FlagBannerIcon, Storefront as StorefrontIcon, UserCircle as UserCircleIcon, CursorClick as CursorClickIcon } from '@phosphor-icons/react';
import { Section, SectionTitle, Lead } from '../Section';
import { channels, clinicians, type Channel } from '../../data/proposal';
const iconMap: Record<Channel['icon'], React.ElementType> = {
  linkedin: LinkedinLogoIcon,
  email: EnvelopeSimpleIcon,
  whatsapp: WhatsappLogoIcon,
  qr: QrCodeIcon,
  congress: FlagBannerIcon,
  booth: StorefrontIcon,
  rep: UserCircleIcon,
  digital: CursorClickIcon
};
const posters = [{
  clinician: clinicians[1],
  line: 'Would you approach this case differently?',
  cta: 'Scan the case'
}, {
  clinician: clinicians[3],
  line: 'What would you do next?',
  cta: 'Scan to find out'
}];
export function EntryPointsSection() {
  return <Section id="entry-points" index="07" label="Many entry points" fill data-id="element-80" data-mp="7sog89nfdj0o">
      <div className="grid gap-5 lg:grid-cols-[1fr_0.85fr] lg:items-end lg:gap-14" data-id="element-81" data-mp="7qlqzru3jtx0">
        <SectionTitle data-id="element-82" data-mp="2verkw7v1bdw">
          One Teaser.
          <br data-id="element-83" data-mp="hi809imvjix4" />
          Many entry points.
        </SectionTitle>
        <Lead data-id="element-84" data-mp="hkkpmguyovk7">
          The same Snak travels across the whole ecosystem — and different clinicians can appear in
          different places, creating multiple invitations into the Filtek universe.
        </Lead>
      </div>

      <div className="mt-6 grid min-h-0 flex-1 gap-5 lg:grid-cols-[1.15fr_0.85fr]" data-id="element-85" data-mp="mhulofcuw5h0">
        <div className="grid auto-rows-fr gap-3 sm:grid-cols-3" data-id="element-86" data-mp="mjxd93tnq6nu">
          <div className="flex flex-col justify-center rounded-xl border border-primary/40 bg-primary/[0.08] p-5 sm:col-span-3" data-id="element-87" data-mp="10gu1cxie5a11">
            <p className="font-body text-[11px] uppercase tracking-[0.2em] text-primary" data-id="element-88" data-mp="vgg3g8ai7ggq">
              At the centre
            </p>
            <p className="mt-2 font-heading text-2xl leading-tight text-white" data-id="element-89" data-mp="2xafcen05llq9">
              One clinician-led Snak — built once, linked from everywhere
            </p>
            <p className="mt-2 font-body text-sm text-white/55" data-id="element-90" data-mp="165khpmef2e3y">
              Tracked by source, clinician and placement.
            </p>
          </div>
          {channels.map(channel => {
          const Icon = iconMap[channel.icon];
          return <div key={channel.name} className="rounded-xl border border-white/10 bg-white/[0.03] p-4 transition-colors hover:border-secondary/40" data-id="element-91" data-mp="1f7tnjyyqpjb0">
                <Icon size={20} weight="regular" className="text-secondary" aria-hidden="true" data-id="element-92" data-mp="1p2vg74s853ic" />
                <p className="mt-2.5 font-heading text-base text-white" data-id="element-93" data-mp="1tvojdo81o3sb">{channel.name}</p>
                <p className="mt-0.5 font-body text-xs text-white/50" data-id="element-94" data-mp="1xvgmhleo5hqa">{channel.detail}</p>
              </div>;
        })}
        </div>

        <div className="flex min-h-0 flex-col" data-id="element-95" data-mp="27uxptw6g7jj3">
          <p className="font-body text-[11px] uppercase tracking-[0.24em] text-secondary/70" data-id="element-96" data-mp="27vpmlabs7nay">
            Congress activation
          </p>
          <div className="mt-3 grid min-h-0 flex-1 auto-rows-fr gap-3" data-id="element-97" data-mp="2hwi6kxwcg5wv">
            {posters.map(({
            clinician,
            line,
            cta
          }) => <article key={clinician.id} className="flex items-center gap-4 rounded-xl border border-white/12 bg-[#02241e] p-4" data-id="element-98" data-mp="2805fm7s6o65t">
                <img src={clinician.portrait} alt={`Portrait of ${clinician.name}`} className="h-full max-h-32 w-20 shrink-0 rounded-lg object-cover object-[50%_20%]" data-id="element-99" data-mp="30pcjlmaepnyg" />
                <div className="min-w-0" data-id="element-100" data-mp="2qyhortj3hg1e">
                  <h3 className="font-heading text-lg text-white" data-id="element-101" data-mp="2qx6jtqdwy28p">{clinician.name}</h3>
                  <p className="mt-1.5 font-heading text-base leading-snug text-primary" data-id="element-102" data-mp="2mxpfj0a83b54">{line}</p>
                  <p className="mt-2.5 inline-flex items-center gap-2 rounded-full border border-primary/50 px-3 py-1 font-body text-[11px] font-semibold uppercase tracking-[0.16em] text-primary" data-id="element-103" data-mp="3jh56r02soey9">
                    <QrCodeIcon size={13} weight="bold" aria-hidden="true" data-id="element-104" data-mp="2z5swppy5t4kh" />
                    {cta}
                  </p>
                </div>
              </article>)}
          </div>
          <p className="mt-3 font-body text-sm text-white/45" data-id="element-105" data-mp="2q88q01hj2g2h">
            QR cards and posters around the congress — each one a different clinician, each one a
            different way in.
          </p>
        </div>
      </div>
    </Section>;
}